import { Button, Input, InputRef } from "antd-mobile";
import { ScanningOutline } from "antd-mobile-icons";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

interface ScanInputProps {
    placeholder: string;
    value: string;
    onScan: (code: string) => void;
    onClick?: () => void;
    onChange?: (value: string) => void;
}

export const ScanInput = forwardRef<HTMLInputElement, ScanInputProps>(({
    placeholder,
    value = '',
    onScan = (scanValue: string) => { },
    onClick = () => { },
    onChange = () => { },
}, ref) => {
    const [scanValue, setScanValue] = useState(value);
    const inputRef = useRef<InputRef>(null);

    useImperativeHandle(ref, () => inputRef.current?.nativeElement as HTMLInputElement);

    useEffect(() => {
        setScanValue(value);
    }, [value]);

    return (
        <div className="flex items-center mb-2 border rounded">
            <Input
                ref={inputRef}
                className="flex-1 p-2"
                placeholder={placeholder}
                value={scanValue}
                onChange={(e) => {
                    setScanValue(e);
                    onChange(e);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onScan(scanValue);
                    }
                }}
            />
            <Button
                fill={"none"}
                className="ml-2 bg-transparent border-0"
                onClick={onClick}
            >
                <ScanningOutline fontSize={24} />
            </Button>
        </div>
    )
});